exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-box[data-v-769396b0]{min-height:50px}.info-box .order-info .list-item[data-v-769396b0]{padding:10px}\n", ""]);

// exports
